import React, { Component, useState } from 'react'; 
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from './CustomModal'
import ModalHeader from './ModalHeader'
import dateFormater from '../Classes/FormatDate'
import ModalBody from './ModalBody'
import ModalFooter from '../Components/ModalFooter'
import { uploadPaymentAcknowledgement } from './../store/actions/fileActions'
import { postMapPaymentAcknowledgementDocumentIDsToInvoice } from './../store/actions/poDetailsActions'
import { updateStatusForFinance } from '../store/actions/invoiceActions';
import swal from '@sweetalert/with-react';
import { connect } from 'react-redux'

function formatedDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

class UploadAcknowledgementPopUp extends Component {

    constructor(props) {
        super(props);
        this.state={
            reviseForm:{
                file:[],
                comment:""
            },
            utrNo: '',
            paymentDate: '',
            invoiceIDs: this.props.invoiceIds,
            uploadedBy: this.props.uploadedBy,
            TotalPaidAmount: this.props.TotalPaidAmount,
            InvoiceAmountinINR: this.props.InvoiceAmountinINR,
            InvoiceNo: this.props.InvoiceNo,
            maxDate: formatedDate(new Date()),
        }
        
        this.modal= this.modal.bind(this); 
        
    }

   
    modal = async() => {
        this.props.toggleUploadAcknowledgementModal(false)
    } 

    handleFileInput =(event)=>{
        let reviseForm = this.state.reviseForm
        
        reviseForm.file.push(event.target.files[0])
        // reviseForm.file = fileList
        this.setState({reviseForm});
        console.log(this.state.reviseForm)
    }

    // handle date input
    handlePaymentDate=(event)=> { this.setState({paymentDate: event.target.value}) }

    // handle file upload
    onclickUpload = async () => {
        
        if (this.state.reviseForm.file.length < 1) {
            swal("Please upload some valid document", { icon: "error" })
            return false;
        }
        if (this.state.utrNo.trim() === '') {
            swal("Please enter UTR number", { icon: "error" })
            return false;
        }
        swal("Document is uploading...", { button: false, icon: "info" })
        var result = await this.props.uploadPaymentAcknowledgement(this.state.reviseForm.file)
        for(let i=0; i<this.state.invoiceIDs.length; i++){
            console.log(this.state.invoiceIDs[i],this.state.TotalPaidAmount[i],this.state.InvoiceAmountinINR[i],"ABhirup")
            // return false
            await this.props.postMapPaymentAcknowledgementDocumentIDsToInvoice(
                this.state.invoiceIDs[i],
                this.state.InvoiceNo[i],
                this.state.uploadedBy,
                this.state.paymentDate,
                result.results[0].DocumentId,
                this.state.utrNo,
                ''
            )
            // if(parseInt(this.state.TotalPaidAmount[i]) < parseInt(this.state.InvoiceAmountinINR[i]))
                // this.props.updateStatusForFinance(8,this.state.invoiceIDs[i],this.state.InvoiceAmountinINR[i], this.state.TotalPaidAmount[i])
            // else
                // this.props.updateStatusForFinance(8,this.state.invoiceIDs[i],this.state.InvoiceAmountinINR[i])
        }
        await this.modal()
        // await this.props.dataSyns
        // window.location.reload()
    }

    updateTextInput=(e)=>{

        this.setState({
            utrNo: e.target.value
        })

    }
    
 render(){    
 
 return(
     <div>
      
        <div>
        <Modal  isOpen={this.props.action} className="modal-lg">
            <div className={"modal-bg" + (this.props.action === 'false'  ? 'open' : '')}>
                <div className={"modal-bg" + (this.state.OpenVersionModal == true  ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header ">
                            <div className="modal-text"><h4>Upload Documents</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                <ModalBody Style="modal-body ">
                    <div className="row ">
                        <div className="col-8"></div>
                        <div className="col-4 pb-2">
                            {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-6">Payment Advice :</div>
                        <div className="col-md-6"><input type="file" onChange={(e)=>this.handleFileInput(e)} className="form-control-file"/></div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-6">UTR No. :</div>
                        <div className="col-md-6"><input type="text" value={this.state.utrNo} onChange={this.updateTextInput} className="form-control"/></div>
                        {/* <div className="col-md-6"><input type="text" onChange={(e) => {this.updateTextInput(e)}} className="form-control"/></div> */}
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-6">Payment Date :</div>
                        <div className="col-md-6"><input type="date" max={this.state.maxDate} value={this.state.paymentDate} onChange={this.handlePaymentDate} className="form-control"/></div>
                    </div>
                </ModalBody>
                </div>
                <div className="">    
                    <ModalFooter FooterStyle="modal-footer ">
                        <div>
                            <button className="btn2 btn-sms1 mt-2 ml-2 float-right rounded-pill" type="submit" onClick={this.onclickUpload}>Submit</button>
                            <button className="btn2 btn-sms1 mt-2 ml-2 rounded-pill" onClick={this.modal} type="submit">Close</button> 
                        </div>
                    </ModalFooter>
                </div>
            </div>
        </Modal>         
        </div>
        
    </div>
       
     
 )
 
  }
}
 
const mapStateToProps  = (state) => ({ file: state.file, poDetails: state.poDetails, invoices: state.invoice })
export default connect(mapStateToProps, { uploadPaymentAcknowledgement, postMapPaymentAcknowledgementDocumentIDsToInvoice, updateStatusForFinance })(UploadAcknowledgementPopUp)



